/* ============================================================================
   DEV AASTHA — PDP V2 · JUDGE.ME "SAMPLE REVIEW" HATAO
   ----------------------------------------------------------------------------
   Owner ne 6 Aug 2026 ko Silver Elephant par ye pakda:
       "This is a sample review to demonstrate Judge.me review widget"
       — John Smith, lorem ipsum body, aur uspar VERIFIED PURCHASE ka thappa.

   Wo Judge.me ka DEMO review hai, kisi asli grahak ka nahi. Use dikhana — aur
   wo bhi "Verified purchase" ke saath — grahak ko dhokha hai.

   ⚠ Ye ab pehle se ZYADA zaroori hai: `da-pdp-v2-judgeme.js` ab reviews ko
   `COLLECTED` array me JAMA karta hai (Judge.me ke agle page laane ke liye).
   Agar sample review kisi ek poll me bhi mil gaya to wo hamesha ke liye list me
   atak jaata — asli reviews aane ke baad bhi.

   Ye file `.rev` cards ko dekhti rehti hai aur sample wala card hata deti hai.
   MutationObserver isliye ki judgeme bridge baar-baar re-render karta hai
   (har extra page ke baad).

   ⚠ Teen alag pehchaan par rok hai, aur har jaanch me DO-DO shart hain — sirf
   "sample" shabd se kisi asli grahak ka review nahi hatega.

   ⚠⚠ ASLI ILAAJ JUDGE.ME ADMIN ME HAI — wahan se ye sample review DELETE karo
   (Judge.me -> Reviews -> dhoondo "sample review to demonstrate" -> Delete).
   Ye file sirf DHAAL hai; jab tak wo review wahan hai, uska JSON-LD aur uska
   apna widget bhi use kahin aur dikha sakta hai.
   ============================================================================ */
(function () {
  var HOST = document.querySelector('[data-da-reviews]');
  if (!HOST) return;

  function looksLikeSample(card) {
    var title = (card.querySelector('.revh') || {}).textContent || '';
    var body  = (card.querySelector('p') || {}).textContent || '';
    var whoEl = card.querySelector('.rwho');
    var author = whoEl && whoEl.childNodes[0] ? whoEl.childNodes[0].textContent : '';

    var t = title.toLowerCase();
    var b = body.toLowerCase();
    var a = (author || '').trim().toLowerCase();

    if (t.indexOf('sample review') > -1 && t.indexOf('judge.me') > -1) return true;
    if (a === 'john smith' && b.indexOf('sample review body') > -1) return true;
    /* Judge.me ke demo body ka lorem-ipsum fingerprint */
    if (b.indexOf('ut et excepturi et modi') > -1) return true;

    return false;
  }

  function sweep() {
    var removed = 0;
    Array.prototype.slice.call(HOST.querySelectorAll('.rev')).forEach(function (c) {
      if (looksLikeSample(c)) { c.remove(); removed++; }
    });
    return removed;
  }

  sweep();

  /* bridge har extra page ke baad poora `.revs` dobara likhta hai — tab dobara
     chalna zaroori hai */
  if (window.MutationObserver) {
    new MutationObserver(function () { sweep(); }).observe(HOST, { childList: true });
  }

  /* Judge.me async hai — do-teen aur koshish */
  setTimeout(sweep, 1200);
  setTimeout(sweep, 3000);
  setTimeout(sweep, 6000);
  window.addEventListener('load', sweep);
})();
